import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { Select } from '@telus-uds/components-web';

import { CONSTANT } from '../../../../../utils/constant';
import request, { isAdmin, isSalesManager } from '../../../../../utils/request';

// SOF1 / SOF-3356 — Manage Account: order-access dropdown for SM + DEALER.
// Per Clarifications 2026-04-28, only Admin can mutate this field; when the
// requester is the same SM viewing their own profile, the field is read-only.
const OrderAccess = ({ fieldData, setFieldData, formErrors, setFormErrors }) => {
  const {
    KEYS: {
      REQUIRES_ORDER_ACCESS: { YES, NO }
    }
  } = CONSTANT;

  useEffect(() => {
    return () => {
      // Cascading clears are handled in form.js handleSubmit (T020).
    };
  }, []);

  const profile = request.getProfile();
  const isSelfSm =
    isSalesManager && profile && fieldData && profile.id === fieldData.id;
  const readOnly = isSelfSm && !isAdmin;
  const fieldError = 'requiresOrderAccess' in formErrors;

  return (
    <Select
      label="Do you require access to create / submit orders? *"
      placeholder="Please select..."
      value={fieldData.requiresOrderAccess || ''}
      disabled={readOnly}
      validation={fieldError ? 'error' : undefined}
      feedback={fieldError ? formErrors.requiresOrderAccess.message : undefined}
      onChange={value => {
        if (!value || ![YES, NO].includes(value)) {
          setFormErrors({
            ...formErrors,
            requiresOrderAccess: {
              message: 'Please select an order access option.'
            }
          });
        } else {
          const errors = { ...formErrors };
          delete errors.requiresOrderAccess;
          setFormErrors({ ...errors });
        }
        setFieldData(previousValue => ({
          ...previousValue,
          requiresOrderAccess: value
        }));
      }}
    >
      <Select.Item value={YES}>Yes</Select.Item>
      <Select.Item value={NO}>No</Select.Item>
    </Select>
  );
};

OrderAccess.propTypes = {
  formErrors: PropTypes.shape({
    requiresOrderAccess: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    id: PropTypes.number,
    role: PropTypes.string,
    channels: PropTypes.arrayOf(PropTypes.string),
    requiresOrderAccess: PropTypes.string
  }).isRequired
};

export default OrderAccess;
